/*
 * Arquivo auto-gerado.
 *
 * Gerador: dev/i18n/reindexFiles.js
 *
 * Para atualizar este arquivo, execute:
 *   npm run reindex-langs
 */
/* eslint-disable */
import actions from './actions.json';
import activeDirectory from './active-directory.json';
import adminPanel from './admin-panel.json';
import alarmConfigurations from './alarm-configurations.json';
import alarmsAndWarnings from './alarms-and-warnings.json';
import analysisProcessing from './analysis-processing.json';
import assetInformation from './asset-information.json';
import assetList from './asset-list.json';
import base from './base.json';
import buttons from './buttons.json';
import cma from './cma.json';
import communicationStatusPanel from './communication-status-panel.json';
import dateTime from './date-time.json';
import decimalNumber from './decimal-number.json';
import diagnosticsConfigurations from './diagnostics-configurations.json';
import eCharts from './e-charts.json';
import entities from './entities.json';
import enums from './enums.json';
import expiredSession from './expired-session.json';
import fields from './fields.json';
import flagsDropdown from './flags-dropdown.json';
import general from './general.json';
import header from './header.json';
import installationManager from './installation-manager.json';
import listAggregator from './list-aggregator.json';
import login from './login.json';
import messages from './messages.json';
import moduleInformation from './module-information.json';
import monitoring from './monitoring.json';
import multiselect from './multiselect.json';
import myData from './my-data.json';
import mySigma from './my-sigma.json';
import networkManagement from './network-management.json';
import networkManager from './network-manager.json';
import networkStatus from './network-status.json';
import notification from './notification.json';
import pageDescription from './page-description.json';
import pageName from './page-name.json';
import permissions from './permissions.json';
import profileManager from './profile-manager.json';
import refreshCountdownLabel from './refresh-countdown-label.json';
import regionalManager from './regional-manager.json';
import reports from './reports.json';
import sensors from './sensors.json';
import supervision from './supervision.json';
import userManager from './user-manager.json';
import userMenu from './user-menu.json';

export default {
  actions,
  activeDirectory,
  adminPanel,
  alarmConfigurations,
  alarmsAndWarnings,
  analysisProcessing,
  assetInformation,
  assetList,
  base,
  buttons,
  cma,
  communicationStatusPanel,
  dateTime,
  decimalNumber,
  diagnosticsConfigurations,
  eCharts,
  entities,
  enums,
  expiredSession,
  fields,
  flagsDropdown,
  general,
  header,
  installationManager,
  listAggregator,
  login,
  messages,
  moduleInformation,
  monitoring,
  multiselect,
  myData,
  mySigma,
  networkManagement,
  networkManager,
  networkStatus,
  notification,
  pageDescription,
  pageName,
  permissions,
  profileManager,
  refreshCountdownLabel,
  regionalManager,
  reports,
  sensors,
  supervision,
  userManager,
  userMenu,
};
